//#region ImportSection
import { toast } from "react-toastify";
import { GetLanguageString } from "../helper/Components";
import {
  applyClassToCharacters,
  getStringFromJSX,
} from "../../constants/const";
// #endregion ImportSection

export const ShowToast = (toastId, messageKey, status = "success") => {
  const msg = getStringFromJSX(
    applyClassToCharacters(
      getStringFromJSX(<GetLanguageString props={messageKey} />),
      "ur"
    )
  );

  toast.update(toastId, {
    render: msg,
    type: status,
    isLoading: false,
    autoClose: 3000,
  });
};
